import { useEffect, useRef } from "react";

import { useSlideBar } from "2g-slidebar";
import { useAuthProvider } from "2g-auth";

import { useNotifikaceUser } from "b2b/api/hooks";

export default function useNotifikaceIcon() {
  const intervalRef = useRef();
  const { userInfo: { username } = {} } = useAuthProvider();
  const loader = useNotifikaceUser({ username: username });
  const slidebar = useSlideBar();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      loader.reload();
    }, window.initialProps?.notificationsReloadInterval || 60000);
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [loader.reload]);

  return {
    slidebar,
    ...loader,
    unreadCount:
      loader.data && loader.data.filter(item => !item.prectena).length
  };
}
